const documents = {
  en: {
    doc_sterile_probe: "https://register.erbe-med.com/productfinder/Marketingmaterialien/85100-140_ERBE_EN_FiAPC_probes__D024677.pdf",
    doc_pocket_guide: "https://register.erbe-med.com/fileadmin/pdf/85800-135_Pocketguide_2_Auflage_110x190.pdf",
    doc_gastro: "https://register.erbe-med.com/productfinder/Marketingmaterialien/85800-131_ERBE_EN_Application_brochure_of_gastroenterology__D064045.pdf",
    doc_apc: "https://register.erbe-med.com/productfinder/Marketingmaterialien/85800-138_ERBE_EN_Basic_knowledge_of_APC__D134038.pdf",
  },
  de: {
    doc_sterile_probe: "https://register.erbe-med.com/productfinder/Marketingmaterialien/85100-040_ERBE_DE_FiAPC-Sonden__D024643.pdf",
    doc_pocket_guide: "https://register.erbe-med.com/fileadmin/pdf/85800-135_Pocketguide_2_Auflage_110x190.pdf",
    doc_gastro: "https://register.erbe-med.com/productfinder/Marketingmaterialien/85800-031_ERBE_DE_Anwenderbroschuere_Gastroenterologie__D064043.pdf",
    doc_apc: "https://register.erbe-med.com/productfinder/Marketingmaterialien/85800-038_ERBE_DE_Basiswissen_der_APC__D134036.pdf",
  }
}

export const createDocumentsModule = () => {
  return {
    state: {},
    getters: {
      allDocuments: () => {
        const de = Object.entries(documents.de).map(([key, url]) => ({ key: key + "_" + "de", url }))
        const en = Object.entries(documents.en).map(([key, url]) => ({ key: key + "_" + "en", url }))
        return de.concat(en)
      },
      allDocumentsForLanguage: () => (language) => {
        return Object.entries(documents[language].map(([key, url]) => ({ key: key + "_" + language, url })))
      },
      doc_sterile_probe: (state, getters, rootState) => {
        return documents[rootState.language]["doc_sterile_probe"];
      },
      doc_pocket_guide: (state, getters, rootState) => {
        return documents[rootState.language]["doc_pocket_guide"];
      },
      doc_gastro: (state, getters, rootState) => {
        return documents[rootState.language]["doc_gastro"];
      },
      doc_apc: (state, getters, rootState) => {
        return documents[rootState.language]["doc_apc"];
      },
    },
  };
};
